import { useTheme } from "app/shared";
import { FC } from "react";
import { BsLightningCharge } from "react-icons/bs";
import styles from "./CompetitiveEdge.module.scss";

interface CompetitiveEdgeProps {
  edges: string[];
}

const CompetitiveEdge: FC<CompetitiveEdgeProps> = ({ edges }) => {
  const { theme } = useTheme();
  return (
    <div
      className={`${styles.container} ${
        theme === "dark" ? styles.darkTheme : ""
      }`}
    >
      <h2 className={styles.title}>Competitive Edge</h2>

      <ul className={styles.edgeList}>
        {edges.map((edge, index) => (
          <li
            key={index}
            className={`${styles.edgeItem} ${
              theme === "dark" ? styles.darkTheme : ""
            }`}
          >
            <BsLightningCharge color="#E90092" />
            {edge}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CompetitiveEdge;
